import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75f0d4b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-bar" }
const _hoisted_2 = { class: "main-bar__numbers" }
const _hoisted_3 = { class: "main-bar__icon" }
const _hoisted_4 = {
  key: 0,
  class: "main-bar__threshold main-bar__threshold--high"
}
const _hoisted_5 = {
  key: 1,
  class: "main-bar__threshold main-bar__threshold--medium"
}
const _hoisted_6 = {
  key: 2,
  class: "main-bar__threshold main-bar__threshold--light"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
      ]),
      _createElementVNode("h6", null, _toDisplayString(_ctx.current) + " / " + _toDisplayString(_ctx.max), 1)
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle({
				background: `linear-gradient(90deg, #181818 0%, #181818 ${_ctx.percent}%, transparent ${_ctx.percent}%)`,
			}),
      class: "main-bar__bar"
    }, [
      (_ctx.percent > 10)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.percent > 25)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.percent > 50)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}